import { Answer } from './answers/answer.model';
import { Person } from './question/question-person.model';
import { Worksite } from './question/question-worksite.model';

export interface Begaran {
  id: string;
  status: BegaranStatus;
  projektStartDate: Date;
  projektEndDate: Date;
  rapportLista: Rapport[];
  projektledare: Person;
  firmatecknareList: Person[];
  worksites: Worksite[];
  effektaBudgetAnswer: Answer;
  budgetMedAndring: BudgetMedAndring;
}

export interface BudgetMedAndring {
  worksites: Worksite[];
  senastBeslut?: Date;
}

export interface Rapport {
  id: string;
  titelSv: string;
  titelEn: string;
  senast: Date;
  inskickad: Date;
  bedomdDatum?: Date;
  typ: RapportTypEnum;
}

export enum BegaranStatus {
  Aktiv = 0,
  InskickadAvAnvandare,
  SkickadTillEffekta,
  Diarieford,
  Avbruten,
  Avslagen,
  Beviljad,
  Komplettera,
}

export enum RapportTypEnum {
  Startrapport = 44,
  Kompletteranderapport = 56,
  Lagesrapport = 11,
  Projektavtal = 33,
  Slutrapport = 12,
  Efterrapport = 55,
}
